export default {"src":"/_next/static/media/coco-studying.467b2468.svg","height":182,"width":238,"blurWidth":0,"blurHeight":0};